import { render } from "./TicketPackage.vue?vue&type=template&id=6f2e8193&scoped=true"
import script from "./TicketPackage.vue?vue&type=script&lang=js"
export * from "./TicketPackage.vue?vue&type=script&lang=js"

import "./TicketPackage.vue?vue&type=style&index=0&id=6f2e8193&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f2e8193"]])

export default __exports__